import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-circle-process-filled",
  "use": "rt-base-circle-process-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-circle-process-filled\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM264 576c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z m248 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z m248 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z\" p-id=\"3207\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/circle-process-filled.svg
// module id = 1706
// module chunks = 137